import React, { useEffect, useState, Fragment } from 'react';
import { Card, Col, Container, Form, Row, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { obtenerDatosGestionImplicado, obtenerTareasPendientes } from '../../store/actions/administracion-caso-action';
import { getAntecedentesCaso, getModalesConsulta } from '../../api/api-consultar-caso';
import Acciones from './acciones';
import { Auth } from 'recupero-comunes';

// Menu Flotante
import { makeStyles } from '@material-ui/core/styles';
import SpeedDial from '@material-ui/lab/SpeedDial';
import SpeedDialAction from '@material-ui/lab/SpeedDialAction';
import { AiOutlineMenuUnfold } from "react-icons/ai";
import { MdAccountBox, MdPeopleAlt, MdMonetizationOn, MdAccountBalance, MdLock, MdPayments } from "react-icons/md";
import { FaMoneyBillAlt, FaClipboardList } from "react-icons/fa";
//import DetalleCierre from './confirmar-cierre/components/detalle-cierre';
import { serviceGetSolicitudGestion } from '../../api/api-confirmar-cierre';

import { ConsultaMovimientosComponent } from 'defcol-caso-general';
import { ConsultaContactoAseguradoComponent } from 'defcol-caso-general';
import { ConsultaContactoImplicadoComponent } from 'defcol-caso-general';
import { ConsultaProcesosJudicialesComponent } from 'defcol-caso-general';
import { ConsultaGastosHonorariosComponent } from 'defcol-caso-general';
import { ConsultaTrazabilidadHitosComponent } from 'defcol-caso-general';
import { ConsultaPagosEmitidosComponent } from 'defcol-caso-general';
import { SolicitarInformeComponent } from 'defcol-caso-general';
import { ConsultaGestionEntreCiasComponent  } from 'defcol-caso-general';

import { ImFileText } from "react-icons/im";
import { GiLetterBomb } from "react-icons/gi";
import { BsBank } from "react-icons/bs";
import { BsFillCalculatorFill } from "react-icons/bs";
import { GiMoneyStack } from "react-icons/gi";
import { AiOutlineFileSearch } from "react-icons/ai";
import { BiDollarCircle } from "react-icons/bi";
import { FcDiploma1 } from "react-icons/fc";


const useStyles = makeStyles((theme) => ({
    root: {
        height: 380,
        transform: 'translateZ(0px)',
        flexGrow: 1,
    },
    speedDial: {
        position: 'absolute',
        top: '10px',
        right: '-60px',
        zIndex: '150',
        /* marginTop: '-250px', */
        /* right: theme.spacing(5), */
    },
    menu: {
        width: '50px',
        height: '50px',
        zIndex: 250
    },
    tooltip: {
        fontSize: '12px',
        backgroundColor: 'black',
        color: 'white'
    }
}));
const useStylesToltip = makeStyles((theme) => ({
  tooltip: {
      fontSize: '12px',
      backgroundColor: 'black',
      color: 'white'
  }
}));
//

const AdministracionCaso = ({ formik }) => {
    const dispatch = useDispatch();
    const [solicitud, setSolicitud] = useState(null);
    const [idCarpetaResExt, setIdCarpetaResExt] = useState('');
    const [ambitoGestion, setAmbitoGestion] = useState('');
    const [fecAudienciaFormat, setFecAudienciaFormat] = useState('');

    const [implicadoSeleccionado, setImplicadoSeleccionado] = useState('');
    const [ultimoHito, setUltimoHito] = useState('');
    const [fechaHito, setFechaHito] = useState('');

    const data_encargado = useSelector((state) => state.encargadoCompaniaReducer);
    const data_admnistracion = useSelector((state) => state.administracionCasoReducer);
    const { llaves } = data_encargado;
    const { cfg_form43, datosGestionImplicado, datosGestionImplicadoDefault, listaImplicados } = data_admnistracion;

    // Menu FLotante
    const classes = useStyles();
    const classesTooltip = useStylesToltip();
    const [open, setOpen] = React.useState(false);
    const [hidden, setHidden] = React.useState(false);
    const handleOpen = () => { setOpen(true); };
    const handleClose = () => { setOpen(false); };

    // Solicitud Informe Profesional
    const [showInformeProfesional, setShowInformeProfesional] = useState(false)

    const actions = [
        { icon: <ImFileText size={35} style={{ color: '#00aeab' }} />, name: 'Solicitud Informe Profesional', id: '2' }
    ];
    //

    useEffect(() => {
        if (llaves) getSolicitudGestion();
    }, [llaves])

    useEffect(() => {
        setIdCarpetaResExt(
            datosGestionImplicadoDefault && datosGestionImplicadoDefault.datosGestionImplicado.length > 0 &&
                datosGestionImplicadoDefault.datosGestionImplicado[0] && datosGestionImplicadoDefault.datosGestionImplicado[0]['idCarpetaResExt']
                ? datosGestionImplicadoDefault.datosGestionImplicado[0]['idCarpetaResExt'] : ''
        )

        setAmbitoGestion(
            datosGestionImplicadoDefault && datosGestionImplicadoDefault.datosGestionImplicado.length > 0 &&
                datosGestionImplicadoDefault.datosGestionImplicado[0] && datosGestionImplicadoDefault.datosGestionImplicado[0]['ambitoGestion']
                ? datosGestionImplicadoDefault.datosGestionImplicado[0]['ambitoGestion'] : ''
        )

        setFecAudienciaFormat(
            datosGestionImplicadoDefault && datosGestionImplicadoDefault.datosGestionImplicado.length > 0 &&
                datosGestionImplicadoDefault.datosGestionImplicado[0] && datosGestionImplicadoDefault.datosGestionImplicado[0]['fecAudienciaFormat']
                ? datosGestionImplicadoDefault.datosGestionImplicado[0]['fecAudienciaFormat'] : ''
        )
    }, [datosGestionImplicadoDefault])

    useEffect(() => {
        setUltimoHito(
            datosGestionImplicado && datosGestionImplicado.datosGestionImplicado.length > 0 &&
                datosGestionImplicado.datosGestionImplicado[0] && datosGestionImplicado.datosGestionImplicado[0]['ultimoHitoCaso']
                ? datosGestionImplicado.datosGestionImplicado[0]['ultimoHitoCaso'] : ''
        )

        setFechaHito(
            datosGestionImplicado && datosGestionImplicado.datosGestionImplicado.length > 0 &&
                datosGestionImplicado.datosGestionImplicado[0] && datosGestionImplicado.datosGestionImplicado[0]['fechaUltimoHitoFormat']
                ? datosGestionImplicado.datosGestionImplicado[0]['fechaUltimoHitoFormat'] : ''
        )
    }, [datosGestionImplicado])

    const getSolicitudGestion = async () => {
        let query = Buffer.from(JSON.stringify({ idCaso: llaves?.idCaso, idImplicado: 0, grupoSolGestion: 246002 })).toString('base64');
        const response = await serviceGetSolicitudGestion(query);

        setSolicitud(response && response.length > 0 ? response[0] : null);
    }

    const handleAction = async (action) => {
        if (action === "2") setShowInformeProfesional(true);  //Informe Profesional
    }

    const [modalesConsulta, setModalesConsulta] = useState([])
    const [antecedentesCaso, setAntecedentesCaso] = useState(null)

    useEffect(() => {
    
        if (llaves) {
    
          const obtenerAntecedentesCaso = async () => {
            let query = Buffer.from(JSON.stringify({ idOrgCaso: llaves && llaves['idOrgCaso'], idCaso: llaves && llaves['idCaso'] })).toString('base64')
            const response = await getAntecedentesCaso(query);
    
            if (response) {
              setAntecedentesCaso(response);
    
              let query2 = Buffer.from(JSON.stringify({ tipoGestion: response[0]?.IdTipoGestion })).toString('base64')
              const response2 = await getModalesConsulta(query2);
              
              if (response2) {
                setModalesConsulta(response2);
              } else {
                console.log("No se obtuvo Iconos modales!")
              }          
            } else {
              console.log("No se obtuvo Antecedentes del Caso!")
            }
          }
          obtenerAntecedentesCaso();
        }
    }, [llaves])

    const [showSolicitud, setShowSolicitud] = useState(false)
    const [showTraza, setShowTraza] = useState(false)
    const [showProvision, setShowProvision] = useState(false)
    const [showIngreso, setShowIngreso] = useState(false)
    const [showCompromisoPago, setShowCompromisoPago] = useState(false)

    const handleCloseProvision= () => setShowProvision(false)
    const handleCloseIngreso= () => setShowIngreso(false)
    const handleCloseCompromisoPago= () => setShowCompromisoPago(false)

    const handleCloseSolicitud = () => setShowSolicitud(false)
    const handleCloseTraza = () => setShowTraza(false)
    const handleShowSolicitud = () => setShowSolicitud(true)
    const handleShowTraza = () => setShowTraza(true)
    const handleShowProvision = () => setShowProvision(true)
    const handleShowIngreso = () => setShowIngreso(true)
    const handleShowCompromisoPago = () => setShowCompromisoPago(true)
    
    const [showContactoAsegurado, setShowContactoAsegurado] = useState(false);
    const handleShowContactoAsegurado = () => setShowContactoAsegurado(true)

    const [showContactoImplicado, setShowContactoImplicado] = useState(false);
    const handleShowContactoImplicado = () => setShowContactoImplicado(true)

    const [showProcesosJudiciales, setShowProcesosJudiciales] = useState(false);
    const handleShowProcesosJudiciales = () => setShowProcesosJudiciales(true)

    const [showMovimientos, setShowMovimientos] = useState(false);
    const handleShowMovimientos = () => setShowMovimientos(true)

    const [showGastosHonorarios, setShowGastosHonorarios] = useState(false);
    const handleShowGastosHonorarios = () => setShowGastosHonorarios(true)

    const [showPagosEmitidos, setShowPagosEmitidos] = useState(false)
    const handleShowPagosEmitidos= () => setShowPagosEmitidos(true)

    const [showTrazabilidadHitosDef, setShowTrazabilidadHitosDef] = useState(false);
    const handleShowTrazabilidadHitosDef = () => setShowTrazabilidadHitosDef(true)

    const [showDetalleCierre, setShowDetalleCierreDef] = useState(false);
    const handleShowDetalleCierreDef = () => setShowDetalleCierreDef(true)

    const [showGestionEntreCias, setShowGestionEntreCias] = useState(false);
    const handleShowGestionEntreCias = () => setShowGestionEntreCias(true)
    
    const handlersShow = new Map();
    handlersShow.set("c-btn-1", handleShowContactoImplicado);
    handlersShow.set("c-btn-2", handleShowGestionEntreCias);
    handlersShow.set("c-btn-3", handleShowSolicitud);
    handlersShow.set("c-btn-4", handleShowProcesosJudiciales);
    handlersShow.set("c-btn-5", handleShowGastosHonorarios);
    handlersShow.set("c-btn-6", handleShowIngreso);
    handlersShow.set("c-btn-7", handleShowTrazabilidadHitosDef);
    
    handlersShow.set("c-btn-10", handleShowContactoAsegurado);
    handlersShow.set("c-btn-11", handleShowContactoImplicado);
    handlersShow.set("c-btn-12", handleShowGestionEntreCias);
    handlersShow.set("c-btn-13", handleShowProcesosJudiciales);
    handlersShow.set("c-btn-14", handleShowMovimientos);
    handlersShow.set("c-btn-15", handleShowGastosHonorarios);
    handlersShow.set("c-btn-16", handleShowPagosEmitidos);
    handlersShow.set("c-btn-17", handleShowTrazabilidadHitosDef);
    handlersShow.set("c-btn-18", handleShowDetalleCierreDef);
    handlersShow.set("c-btn-19", handleShowCompromisoPago);

    const icons = new Map();
    icons.set("c-btn-1", <MdAccountBox size={35}/>);
    icons.set("c-btn-2", <GiLetterBomb size={35}/>);
    icons.set("c-btn-3", <BsFillCalculatorFill size={35}/>);
    icons.set("c-btn-4", <BsBank size={35}/>);
    icons.set("c-btn-5", <GiMoneyStack size={35}/>);
    icons.set("c-btn-6", <BiDollarCircle size={35}/>);
    icons.set("c-btn-7", <AiOutlineFileSearch size={35}/>);
    
    icons.set("c-btn-10", <MdAccountBox size={35}/>);
    icons.set("c-btn-11", <MdPeopleAlt size={35}/>);
    icons.set("c-btn-12", <GiLetterBomb size={35}/>);
    icons.set("c-btn-13", <MdAccountBalance size={35}/>);
    icons.set("c-btn-14", <MdMonetizationOn size={35}/>);
    icons.set("c-btn-15", <FaMoneyBillAlt size={35}/>);
    icons.set("c-btn-16", <MdPayments size={35}/>);
    icons.set("c-btn-17", <FaClipboardList size={35}/>);
    icons.set("c-btn-18", <MdLock size={35}/>);

    icons.set("c-btn-19", <FcDiploma1 size={35}/>);

    return (
        <Fragment>
            <ConsultaMovimientosComponent
                idCaso={llaves?.idCaso}
                idOrgCaso={llaves?.idOrgCaso}
                codClasCaso={datosGestionImplicadoDefault?.datosGestionImplicado[0]?.codClasCaso}
                showModal={showMovimientos}
                setShowModal={setShowMovimientos}
            />

            <ConsultaContactoAseguradoComponent
                idCaso={llaves?.idCaso}
                idOrgCaso={llaves?.idOrgCaso}
                tipoGestion={datosGestionImplicadoDefault?.datosGestionImplicado[0]?.codTipoGestion}
                showModal={showContactoAsegurado}
                setShowModal={setShowContactoAsegurado}
            />

            <ConsultaContactoImplicadoComponent
                idCaso={llaves?.idCaso}
                idOrgCaso={llaves?.idOrgCaso}
                tipoGestion={datosGestionImplicadoDefault?.datosGestionImplicado[0]?.codTipoGestion}
                showModal={showContactoImplicado}
                setShowModal={setShowContactoImplicado}
            />

            <ConsultaProcesosJudicialesComponent
                idCaso={llaves?.idCaso}
                idOrgCaso={llaves?.idOrgCaso}
                tipoGestion={datosGestionImplicadoDefault?.datosGestionImplicado[0]?.codTipoGestion}
                showModal={showProcesosJudiciales}
                setShowModal={setShowProcesosJudiciales}
            />

            <ConsultaGastosHonorariosComponent
                idCaso={llaves?.idCaso}
                idOrgCaso={llaves?.idOrgCaso}
                showModal={showGastosHonorarios}
                setShowModal={setShowGastosHonorarios}
            />

            <ConsultaTrazabilidadHitosComponent
                idCaso={llaves?.idCaso}
                idOrgCaso={llaves?.idOrgCaso}
                tipoGestion={datosGestionImplicadoDefault?.datosGestionImplicado[0]?.codTipoGestion}
                showModal={showTrazabilidadHitosDef}
                setShowModal={setShowTrazabilidadHitosDef}
            />

            <ConsultaPagosEmitidosComponent
                idCaso={llaves?.idCaso}
                idOrgCaso={llaves?.idOrgCaso}
                showModal={showPagosEmitidos}
                setShowModal={setShowPagosEmitidos}
            />
            <ConsultaGestionEntreCiasComponent
                idCaso={llaves?.idCaso}
                idOrgCaso={llaves?.idOrgCaso}
                showModal={showGestionEntreCias}
                setShowModal={setShowGestionEntreCias}
            />
            <SolicitarInformeComponent
                idCaso={llaves?.idCaso}
                idOrgCaso={llaves?.idOrgCaso}
                showModal={showInformeProfesional}
                setShowModal={setShowInformeProfesional}
            />

            {/*<DetalleCierre
                showModal={showDetalleCierre}
                setShowModal={setShowDetalleCierre}
                implicado={0}
                solicitud={solicitud}
            />*/}

            <Container className='mb-4 mt-2 position-relative'>
                <SpeedDial
                    ariaLabel="SpeedDial tooltip example"
                    className={classes.speedDial}
                    hidden={hidden}
                    icon={<AiOutlineMenuUnfold size={30} />}
                    onClose={handleClose}
                    onOpen={handleOpen}
                    open={true}
                >
                    {actions.map((action) => (
                        <SpeedDialAction
                            key={action.id}
                            icon={action.icon}
                            tooltipTitle={action.name}
                            className={classes.menu}
                            onClick={() => handleAction(action.id)}
                            TooltipClasses={classesTooltip}
                        />
                    ))}
                </SpeedDial>

                <Card>
                    <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#4F517A', color: 'white' }}>
                        {(cfg_form43 && cfg_form43.cfg_form43['formbasegestiondefensacia-title-tareas-pends']) ? cfg_form43.cfg_form43['formbasegestiondefensacia-title-tareas-pends'] : 'Consulta de Gestiones Caso'}
                    </Card.Header>

                    <Card.Body style={{ paddingBottom: '0' }}>
                        <Row className='d-flex mt-4' >
                            <Col style={{alignSelf:'start'}}>
                                {modalesConsulta && modalesConsulta?.map((modal, index) => {
                                    return (                        
                                        <OpenModalComponent
                                        modal={modal} 
                                        handleShow={handlersShow.get(modal.idBtn)}
                                        icon={icons.get(modal.idBtn)}
                                        />                          
                                    )
                                })
                                }
                            </Col>
                        </Row>
                    </Card.Body>
                    <Acciones implicadoSeleccionado={implicadoSeleccionado} />
                </Card>
            </Container>
        </Fragment>
    )
}
export default AdministracionCaso

const OpenModalComponent=({modal, handleShow, icon})=>{  
  return (
    <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">{modal.toltip}</Tooltip>}>
      <Button variant='outline-info' id={modal.id} className='mx-1' onClick={handleShow}>
        {icon}
      </Button>
    </OverlayTrigger>
  )
}